import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './posthog';

// Captures a $pageview on every route change. The initial page load is already
// captured by posthog.init (capture_pageview: true), so the first location is
// only remembered, not re-sent.
const PageTracker = () => {
  const location = useLocation();
  const lastPath = useRef<string | null>(null);

  useEffect(() => {
    const path = location.pathname + location.search;
    if (lastPath.current === path) return;

    const isInitialLoad = lastPath.current === null;
    lastPath.current = path;

    if (!isInitialLoad) {
      trackPageView(path);
    }
  }, [location]);

  return null;
};

export default PageTracker;
